import { render, staticRenderFns } from "./property-locationBuildings.vue?vue&type=template&id=7ba35980&"
import script from "./property-locationBuildings.vue?vue&type=script&lang=js&"
export * from "./property-locationBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports